<!-- used to trick browsers into autofilling these inputs instead of the actual username and password inputs -->
<input
  style="display: none"
  type="password"
  name="username"
  autocomplete="username" />
<input
  style="display: none"
  type="password"
  name="old password"
  autocomplete="password" />
<input
  style="display: none"
  type="password"
  name="password"
  autocomplete="new-password" />
<div id="login-page" class="primary-background">
  <div id="login-form">
    <p-card>
      <div>
        <div class="school-logo-wrapper">
          <img
            style="max-width: 40%; margin-bottom: 3px"
            id="school-logo"
            src="school-assets/school_logo.png"
            alt="" />
        </div>
        <div class="school-logo-wrapper-dark">
          <img
            style="max-width: 40%; margin-bottom: 3px"
            id="school-logo-dark"
            src="school-assets/school_logo_dark.png"
            alt=""
            *ngIf="!darkLogoError; else forgotDarkLogoFallback"
            (error)="darkLogoError = true" />
          <ng-template #forgotDarkLogoFallback>
            <img
              style="max-width: 40%; margin-bottom: 3px"
              id="school-logo-dark"
              src="school-assets/school_logo.png"
              alt="" />
          </ng-template>
        </div>
        <div *ngIf="hasVerificationToken && loading && !passwordForm" class="form-holder" style="padding: 1rem; text-align: center">
          <app-loading-dots size="5px"></app-loading-dots>
        </div>

        <div *ngIf="!passwordSent && usernameForm && !hasVerificationToken">
          <div class="form-holder">
            <div>
              <app-input
                [control]="usernameForm.get('username')"
                [label]="'username' | translation"
                [placeholder]="'username' | translation"
                [disabled]="loading">
              </app-input>
              <p class="error-msg" *ngIf="error">{{ error }}</p>
              <div class="button-holder">
                <app-button status="secondary" (click)="routeToLogin()">
                  {{ 'cancel' | translation }}
                </app-button>
                <app-button
                  [isProcessing]="loading"
                  status="primary"
                  (click)="startForgot()"
                  [disabled]="usernameForm.invalid || loading">
                  {{ 'submit' | translation }}
                </app-button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="passwordSent">
          <div style="padding: 1rem; text-align: center">
            <p>{{ 'password_recovery_instructions_sent' | translation }}</p>
          </div>
        </div>

        <div *ngIf="hasVerificationToken && policies && passwordForm">
          <div class="form-holder">
            <label class="app-label">{{
              'password_new_set' | translation
            }}</label>
            <p>
              <strong>{{ 'password_requirement' | translation }}</strong>
            </p>

            <p
              *ngIf="policies?.MinimumLength > 0"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.minlength),
              }">
              {{ 'requirement_minimum_length' | translation }} :
              {{ policies.MinimumLength }}
            </p>
            <p
              *ngIf="policies?.RequireUppercase"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveUpercase),
              }">
              {{ 'requirement_uppercase' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireLowercase"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveLowercase),
              }">
              {{ 'requirement_lowercase' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireNumbers"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveNumber),
              }">
              {{ 'requirement_number' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireSymbols"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveSpecialCharacter),
              }">
              {{ 'requirement_special_character' | translation }}: ^ $ * . [ ]
              {{ '{' }} {{'}''}} ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ `
            </p>

            <app-input
              [control]="usernameForm.get('username')"
              [label]="'username' | translation"
              [placeholder]="'username' | translation"
              [disabled]="loading">
            </app-input>
            <app-input
              [control]="passwordForm.get('verificationCode')"
              [label]="'verification_code' | translation"
              [placeholder]="'verification_code' | translation"
              [disabled]="loading">
            </app-input>

            <app-input
              [control]="passwordForm.get('newPw')"
              [label]="'password_new' | translation"
              [placeholder]="'new_password' | translation"
              [hideInput]="true"
              [disabled]="loading">
            </app-input>

            <app-input
              [control]="passwordForm.get('confirmPw')"
              [label]="'password_confirm' | translation"
              [placeholder]="'password_confirm' | translation"
              [hideInput]="true"
              [disabled]="loading">
            </app-input>

            <password-strength-meter
              (strengthChange)="passwordStrength = $event"
              [minPasswordLength]="policies?.MinimumLength || 7"
              [enableFeedback]="true"
              [password]="
                passwordForm.get('newPw').value
              "></password-strength-meter>

            <p class="error-msg" *ngIf="error">{{ error }}</p>
            <div class="button-holder">
              <app-button status="secondary" (click)="routeToLogin()">
                {{ 'cancel' | translation }}
              </app-button>

              <app-button
                [isProcessing]="loading"
                status="primary"
                (click)="submitNewPw()"
                [disabled]="
                  passwordForm.invalid || usernameForm?.invalid || loading
                ">
                {{ 'submit' | translation }}
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
